import { TBoardId } from '../../../../types/types';
import { ThunkAction } from '../../../../types/actions';
import { getBoardCardsByStatuses } from '../../../../store/model/selectors/getBoardCardsByStatuses';
import { TStatus } from '../../../../types/model';
import { cardRestGetSections } from '../card/api/helper/cardRestGetSections';
import { getChecklistsCardsRequest } from './helpers/getChecklistsCardsRequest';

export const checklistsLoad = (
    boardId: TBoardId,
    statuses: TStatus[] = [TStatus.STATUS_ACTIVE],
): ThunkAction => {
    return (
        dispatch,
        getState
    ) => {
        const state = getState();
        const cards = getBoardCardsByStatuses(state, boardId, statuses);
        const cardsRequest = getChecklistsCardsRequest(state, cards);
        if (!cardsRequest.length) return Promise.resolve();

        return dispatch(cardRestGetSections(cardsRequest));
    }
}
